export function getCardOwnerAllDescHelper(row: any) {
    var cardOwner = row.cardOwner || "";
    cardOwner = cardOwner.length > 0 ? cardOwner + ", " : "";
    var cardBrand = row.cardBrand || "";
    cardBrand = cardBrand.length > 0 ? cardBrand + ", " : "";
    var cardType = row.cardType || "";
    cardType = cardType.length > 0 ? cardType + ", " : "";
    var cardName = row.cardName || "";
    var allDesc = cardOwner + cardBrand + cardType + cardName;
    return allDesc;
}